import { render } from "./ModalTicket.vue?vue&type=template&id=229fce4a&scoped=true"
import script from "./ModalTicket.vue?vue&type=script&lang=js"
export * from "./ModalTicket.vue?vue&type=script&lang=js"

import "./ModalTicket.vue?vue&type=style&index=0&id=229fce4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229fce4a"]])

export default __exports__